/** @jsx isolateComponent */

import { useState } from 'react';

import { isolateComponent } from '@zapier/common-utils';

import { UpgradeModal } from '@zapier/design-system-revenue/src/components/offers';

const FLAG_HAS_SEEN_OUT_OF_TASKS_MODAL = 'hasSeenOutOfTasksModal';

export const setHasSeenOutOfTasksModal = (value: boolean) =>
  localStorage.setItem(FLAG_HAS_SEEN_OUT_OF_TASKS_MODAL, value.toString());

export const LoginOutOfTasksModal = () => {
  const [isOutOfTasksModalVisible, setIsOutOfTasksModalVisible] = useState(
    localStorage.getItem(FLAG_HAS_SEEN_OUT_OF_TASKS_MODAL) === 'false'
  );

  const onClose = () => {
    setHasSeenOutOfTasksModal(true);
    setIsOutOfTasksModalVisible(false);
  };

  return !isOutOfTasksModalVisible ? null : (
    <UpgradeModal onClose={onClose} validationReason="tasks" />
  );
};
